import { Alignment } from '../components/LoyaltyPage/stylesParams';

export interface SimpleRule {
  title: string;
  description: string;
  tierId?: string | null;
  socialMedia?: SocialMediaSettings;
  birthday?: BirthdaySettings;
}

export interface BirthdaySettings {
  description: string;
}

export enum SocialMediaChannel {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  TikTok = 'TIKTOK',
  LinkedIn = 'LINKEDIN',
  X = 'X',
}

export interface SocialMediaSettings {
  channels: SocialMediaSettingsChannel[];
}

export interface SocialMediaSettingsChannel {
  type: SocialMediaChannel;
  url: string;
}

export interface SimpleReward {
  title: string;
  description: string;
  tierId?: string | null;
}

export interface SimpleTier {
  title: string;
  description: string;
  iconUrl: string;
  requiredPoints?: number;
  id?: string | null;
}

export const RTLAlignmentMap = {
  [Alignment.Left]: Alignment.Right,
  [Alignment.Center]: Alignment.Center,
  [Alignment.Right]: Alignment.Left,
};
